import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=4c3757b7&scoped=true&lang=html&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3757b7",
  null
  
)

export default component.exports